export default {
      id: "boy-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#boy",
      toString: function () {
        return this.url;
      }
    }